/* eslint-disable no-nested-ternary */
import * as XLSX from 'xlsx';

import { buildExportHeaderRows } from './header-rows';
import { type NodeExportData, type ExportHeaderInfo } from './types';

const TABLE_HEADERS = [
  'Name',
  'Model',
  'IP',
  'Enabled PoE',
  'VLAN IDs',
  'Connect Node',
  'Connect Port',
];

export const exportDevicesToLibreOffice = async (
  devicesData: NodeExportData[],
  filename: string,
  headerInfo?: ExportHeaderInfo,
) => {
  const data: any[] = [];
  const merges: any[] = [];

  if (headerInfo) {
    const headerRows = buildExportHeaderRows(headerInfo, TABLE_HEADERS.length);
    headerRows.forEach((row) => data.push(row));
    if (headerRows.length > 1) {
      merges.push({
        s: { r: 0, c: 0 },
        e: { r: 0, c: TABLE_HEADERS.length - 1 },
      });
    }
  }

  data.push(TABLE_HEADERS);

  let startRow = data.length;

  devicesData.forEach((item) => {
    const portCount = item.Port.length;
    const maxRows = portCount;

    for (let i = 0; i < maxRows; i += 1) {
      const portObj = item.Port[i] || {};

      const rowValues = [
        i === 0 ? item.Name : '',
        i === 0 ? item.Model : '',
        i === 0
          ? item.IP.map((ip) =>
              ip.ip && ip.ip.trim() !== ''
                ? ip.subnetMask && ip.subnetMask.trim() !== ''
                  ? `${ip.ip} (${ip.subnetMask})`
                  : ip.ip
                : '',
            )
              .filter((ip) => ip !== '')
              .join('\n')
          : '',
        i === 0
          ? item.enabledPoe === true
            ? 'Yes'
            : item.enabledPoe === false
              ? 'No'
              : ''
          : '',
        i === 0 ? item.vlanIds?.sort((a, b) => a - b).join(', ') : '',
        portObj.connectNode || '',
        portObj.connectPort || '',
      ];

      data.push(rowValues);
    }

    const endRow = startRow + maxRows - 1;
    if (endRow > startRow) {
      merges.push({ s: { r: startRow - 1, c: 0 }, e: { r: endRow - 1, c: 0 } });
      merges.push({ s: { r: startRow - 1, c: 1 }, e: { r: endRow - 1, c: 1 } });
      merges.push({ s: { r: startRow - 1, c: 2 }, e: { r: endRow - 1, c: 2 } });
      merges.push({ s: { r: startRow - 1, c: 3 }, e: { r: endRow - 1, c: 3 } });
      merges.push({ s: { r: startRow - 1, c: 4 }, e: { r: endRow - 1, c: 4 } });
    }

    startRow += maxRows;
  });

  const ws = XLSX.utils.aoa_to_sheet(data);
  ws['!merges'] = merges;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Report');

  XLSX.writeFile(wb, `${filename}.ods`, { bookType: 'ods', type: 'binary' });
};
